/**
 * Form_Entity type guard.
 *
 * @param {any} formJson Form object from API
 * @returns {boolean} Return true if type is Form_Entity
 */
function validator(formJson: unknown): formJson is Form_Entity {
  if (typeof formJson === "object" && formJson != null) {
    Form_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(formJson).includes(element))
        console.warn(`Field ${element} is null or undefined`);
    });
  }
  return true;
}

export default class Form_Entity {
  static requiredFields = [
    "id",
    "name",
    "code",
    "type",
    "url",
    "config",
    "createdAt",
    "updatedAt",
  ];

  constructor(formJson: unknown) {
    if (validator(formJson)) {
      this.id = formJson.id;
      this.name = formJson.name;
      this.code = formJson.code;
      this.type = formJson.type;
      this.url = formJson.url;
      this.config = formJson.config;
      this.createdAt = formJson.createdAt;
      this.updatedAt = formJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Form_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  name: string;
  code: string;
  type: string;
  url: string;
  config: string;
  createdAt: string;
  updatedAt: string;
}
